export var ProductDonationRecurrenceInterval;
(function (ProductDonationRecurrenceInterval) {
    ProductDonationRecurrenceInterval["OneTime"] = "oneTime";
    ProductDonationRecurrenceInterval["Monthly"] = "monthly";
    ProductDonationRecurrenceInterval["Yearly"] = "yearly";
})(ProductDonationRecurrenceInterval || (ProductDonationRecurrenceInterval = {}));
export var Tribute;
(function (Tribute) {
    Tribute["InMemoryOf"] = "inMemoryOf";
    Tribute["InHonourOf"] = "inHonourOf";
})(Tribute || (Tribute = {}));
